(()=>{function bind(scope=document){const form=scope.querySelector('#NativeProductForm');if(!form||form.dataset.bound)return;form.dataset.bound='true';const cfg=window.TEMPOLOR,p=cfg.product;if(!p)return;const area=form.closest('#buy'),isDesign=area.hasAttribute('data-design-buy'),id=form.querySelector('[name=id]'),qty=form.querySelector('[name=quantity]'),error=form.querySelector('[data-native-error]');let busy=false,view=0,start=null;const money=c=>new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:cfg.currency||'USD'}).format(c/100);const variant=()=>p.variants.find(v=>String(v.id)===id.value)||p.variants[0];

// 兼容中日英韩多语言颜色判断
const isBlackVariant=v=>{const t=(v?.title||'').toLowerCase();return t.includes('black')||t.includes('ブラック')||t.includes('블랙')||t.includes('黑');};
const finish=()=>isBlackVariant(variant())?'black':'white';
const name=()=>{
  const currentLocale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || '';
  const isJa = currentLocale.startsWith('ja') || location.pathname.includes('/ja');
  const isKo = currentLocale.startsWith('ko') || location.pathname.includes('/ko');
  if(finish()==='black'){
    return isJa?'オブシディアンブラック':isKo?'옵시디언 블랙':'Obsidian Black';
  }
  return isJa?'パールホワイト':isKo?'펄 화이트':'Pearl White';
};
const getVariantByIndex=i=>{
  const wantBlack=(i===1);
  return p.variants.find(v=>wantBlack?isBlackVariant(v):!isBlackVariant(v))||p.variants[i];
};

// 调换 3、4 顺序，5 与 6 统一使用更自然的 Home session 标签
const getLabels=()=>{
  const currentLocale=(window.Shopify&&window.Shopify.locale)||document.documentElement.lang||'';
  const isJa=currentLocale.startsWith('ja')||location.pathname.includes('/ja');
  const isKo=currentLocale.startsWith('ko')||location.pathname.includes('/ko');
  if(isJa){
    return ['正面','折りたたみ','サイドビュー','モジュール詳細','ホームセッション','ホームセッション'];
  }
  if(isKo){
    return ['전면','접이식','측면','모듈 상세','홈 세션','홈 세션'];
  }
  return ['Front view','Folded view','Angle view','Single-note module detail','Home session','Home session'];
};

const customGallery=Array.from(area.querySelectorAll('.gallery-thumbs img')).map(img=>img.getAttribute('src')||'');
const gallery=()=>{
  const configured=(area.querySelector('.gallery')?.getAttribute('data-'+finish()+'-images')||'').split(',').map(s=>s.trim()).filter(Boolean);
  if(configured.length>=6) return configured;
  const fallbacks=[
    finish()+'-front.webp',
    finish()+'-folded.webp',
    (finish()==='black'?'black-front.webp':'white-angle.webp'),
    'detail-strings.webp',
    finish()+'-front.webp',
    finish()+'-folded.webp'
  ];
  return fallbacks.map((fallbackName,i)=>configured[i]||(customGallery[i]&&!customGallery[i].includes('shop--')?customGallery[i]:fallbackName));
};

// Gallery entries arrive either as bare filenames or as URLs Liquid already resolved;
// image_url yields protocol-relative URLs in production but root-relative ones under `theme dev`.
const asset=f=>/^(https?:)?\/\/|^\//.test(f)?f:cfg.assetBase+'shop--'+f;
const galleryAsset=(f,width)=>{
  if(!f)return '';
  try{
    const u=new URL(asset(f),location.href);
    if(u.pathname.includes('/cdn/shop/files/')||(/\/cdn\/shop\/t\/\d+\/assets\//.test(u.pathname)&&/\.(webp|png|jpe?g)$/i.test(u.pathname)))u.searchParams.set('width',String(width));
    return u.href;
  }catch(e){
    return f;
  }
};

function renderImage(){
  const g=gallery();
  const totalCount=g.length||6;
  const labels=getLabels();
  const currentLabel=labels[view]||labels[0];
  const targetSrc=galleryAsset(g[view]||g[0],1200);
  const image=area.querySelector('.gallery-main img');
  if(targetSrc){
    const sameImage=new URL(image.getAttribute('src'),location.href).pathname===new URL(targetSrc,location.href).pathname;
    if(!sameImage||!image.hasAttribute('srcset')){
      if(new URL(targetSrc,location.href).pathname.includes('/cdn/shop/files/')){
        image.sizes='(max-width: 767px) calc(100vw - 44px), 50vw';
        image.srcset=[640,960,1600].map(w=>galleryAsset(g[view]||g[0],w)+' '+w+'w').join(', ');
      }else image.removeAttribute('srcset');
      image.src=targetSrc;
    }
  }
  image.alt=name()+' · '+currentLabel;
  area.querySelector('.gallery-main').className='gallery-main gallery-view-'+view;
  area.querySelector('.gallery-main>span').textContent=name();
  area.querySelector('.gallery-navigation>span').textContent=currentLabel;
  const hint=area.querySelector('.gallery-swipe-hint');
  if(hint){
    const currentLocale=(window.Shopify&&window.Shopify.locale)||document.documentElement.lang||'';
    const isJa=currentLocale.startsWith('ja')||location.pathname.includes('/ja');
    const isKo=currentLocale.startsWith('ko')||location.pathname.includes('/ko');
    if(isJa){
      hint.textContent=`スワイプして詳細を見る · ${view+1} / ${totalCount} · ${currentLabel}`;
    }else if(isKo){
      hint.textContent=`스와이프하여 둘러보기 · ${view+1} / ${totalCount} · ${currentLabel}`;
    }else{
      hint.textContent=`Swipe to explore · ${view+1} / ${totalCount} · ${currentLabel}`;
    }
  }
  area.querySelectorAll('.gallery-thumbs button').forEach((b,i)=>{
    b.setAttribute('aria-pressed',String(view===i));
    b.setAttribute('aria-label',labels[i]||currentLabel);
    const thumbImg=b.querySelector('img');
    if(thumbImg&&g[i]){
      const thumbSrc=galleryAsset(g[i],160);
      if(thumbSrc)thumbImg.src=thumbSrc;
    }
  });
}

function update(changeImage=false){
  const v=variant();
  document.querySelectorAll('[data-native-price],[data-native-sticky-price]').forEach(el=>el.textContent=money(v.price));
  document.querySelectorAll('[data-native-compare]').forEach(el=>{el.hidden=!(v.compare_at_price>v.price);el.textContent=v.compare_at_price?money(v.compare_at_price):''});
  document.querySelectorAll('[data-purchase-submit],#NativeProductForm [type=submit]').forEach(el=>{el.disabled=busy||!v.available;let label=el.firstChild;el.dataset.purchaseLabel='Add to cart';if(label?.nodeType===3)label.textContent=busy?'Adding…':v.available?el.dataset.purchaseLabel:'Sold out';});
  const url=new URL(location.href);
  url.searchParams.set('variant',v.id);
  history.replaceState(null,'',url);
  if(isDesign){
    area.querySelector('legend span').textContent=name();
    area.querySelectorAll('.finish-options button').forEach((b,i)=>{const active=(i===1)===(finish()==='black');b.classList.toggle('selected',active);b.setAttribute('aria-pressed',String(active));const option=getVariantByIndex(i);b.disabled=!option||!option.available;});
    document.querySelectorAll('.sticky-buy .purchase-summary>img').forEach(el=>{el.src=galleryAsset(finish()+'-front.webp',120);el.alt=name()+' Melo-D'});
    if(changeImage)renderImage();
  }else if(changeImage&&v.featured_image?.src){
    const image=area.querySelector('.gallery-main img');
    image.src=v.featured_image.src;
    image.removeAttribute('srcset');
  }
}

const query=new URLSearchParams(location.search);
const requested=p.variants.find(v=>String(v.id)===query.get('variant'))||p.variants.find(v=>query.get('color')&&v.title.toLowerCase().includes(query.get('color')));
if(requested)id.value=requested.id;
id.addEventListener('change',()=>{
  view = 0; // 当外部或URL切换变体时，重置为第 1 张图
  update(true);
});

if(isDesign){
  area.querySelectorAll('.finish-options button').forEach((b,i)=>b.addEventListener('click',()=>{
    const v=getVariantByIndex(i);
    if(v){
      // 只要点击颜色卡更换了颜色，相册强制重置回第 1 张（正面图）
      if(String(id.value) !== String(v.id)){
        view = 0;
      }
      id.value=v.id;
      update(true);
    }
  }));
  const setQty=n=>{qty.value=Math.min(10,Math.max(1,n));area.querySelector('output[aria-label=Quantity]').textContent=qty.value;area.querySelector('[aria-label="Decrease quantity"]').disabled=qty.value<=1;area.querySelector('[aria-label="Increase quantity"]').disabled=qty.value>=10};
  area.querySelector('[aria-label="Decrease quantity"]').addEventListener('click',()=>setQty(+qty.value-1));
  area.querySelector('[aria-label="Increase quantity"]').addEventListener('click',()=>setQty(+qty.value+1));
  
  // 支持 6 张图循环
  const move=n=>{
    const count=gallery().length||6;
    view=(view+n+count)%count;
    renderImage();
  };
  area.querySelector('[aria-label="Previous product image"]').addEventListener('click',()=>move(-1));
  area.querySelector('[aria-label="Next product image"]').addEventListener('click',()=>move(1));
  area.querySelectorAll('.gallery-thumbs button').forEach((b,i)=>b.addEventListener('click',()=>{view=i;renderImage()}));
  
  const main=area.querySelector('.gallery-main');
  main.addEventListener('touchstart',e=>{start={x:e.touches[0].clientX,y:e.touches[0].clientY}},{passive:true});
  main.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3)move(dx<0?1:-1);start=null},{passive:true});
  main.querySelector('button').addEventListener('click',()=>{
    const dialog=document.createElement('dialog');
    dialog.className='tempolor-zoom';
    const close=document.createElement('button');
    close.type='button';
    close.textContent='Close ×';
    const img=main.querySelector('img').cloneNode();
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src=galleryAsset(gallery()[view],2000);
    dialog.append(close,img);
    document.body.append(dialog);
    close.onclick=()=>dialog.close();
    dialog.addEventListener('close',()=>dialog.remove());
    dialog.showModal();
  });
  const sticky=document.querySelector('aside[aria-label="Quick purchase"]');
  if(sticky){
    const observer=new IntersectionObserver(([entry])=>sticky.classList.toggle('mobile-purchase-only',entry.isIntersecting),{threshold:0});
    observer.observe(form);
    document.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
  }
}else{
  area.querySelectorAll('[data-gallery-src]').forEach(b=>b.addEventListener('click',()=>{const image=area.querySelector('.gallery-main img');image.src=b.dataset.gallerySrc;image.removeAttribute('srcset')}));
}
update(true);

const getCartRoot=()=>{
  if(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root){
    return window.Shopify.routes.root;
  }
  const r=cfg.root||'/';
  return r.endsWith('/')?r:(r+'/');
};

async function melodAddToCart(variantId, quantity, configuredRoot) {
  const id = Number(variantId), count = Number(quantity);
  if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(count) || count < 1) throw new Error('Please select a valid item and quantity.');
  const rootValue = window.Shopify?.routes?.root || configuredRoot || '/';
  const root = rootValue.endsWith('/') ? rootValue : rootValue + '/';
  const response = await fetch(root + 'cart/add.js', {
    method: 'POST', credentials: 'same-origin',
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
    body: JSON.stringify({items: [{id, quantity: count}]})
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
  const destination = new URL(root + 'cart', location.origin);
  new URLSearchParams(location.search).forEach((value, key) => {
    if (key.startsWith('utm_') || ['fbclid', 'gclid', 'preview_theme_id'].includes(key)) destination.searchParams.set(key, value);
  });
  location.assign(destination.href);
}

window.addEventListener('pageshow',()=>{busy=false;error.hidden=true;update();});
form.addEventListener('submit',async e=>{
  e.preventDefault();
  if(busy||!variant().available||!form.reportValidity())return;
  busy=true;
  error.hidden=true;
  update();
  try{
    await melodAddToCart(id.value, qty.value, getCartRoot());
  }catch(e){
    error.textContent=e.message;
    error.hidden=false;
    busy=false;
    update();
  }
});

}bind();document.addEventListener('shopify:section:load',e=>bind(e.target))})();
